import { hot } from 'react-hot-loader'
import React from 'react'
import CGU from '../components/CGU/CGU'

function App() {
  return (
    <>
      <CGU />
    </>
  )
}

export default hot(module)(App)
